import { useTranslation } from 'react-i18next';

interface Props {
  status: 'good' | 'warn' | 'alert' | 'online' | 'offline' | 'motion' | 'info';
  size?: 'sm' | 'md';
  /**
   * `'device'` cambia SOLO las etiquetas, no los colores. El status que manda
   * el backend para un sensor es disponibilidad del equipo (conectado +
   * batería), NO salud del suelo — está documentado en sensor-view.ts. Con
   * las etiquetas genéricas, un sensor recién conectado salía como "Óptimo"
   * al lado de nueve parámetros en ALERT rojo: dos afirmaciones opuestas
   * sobre la misma pantalla, y la de arriba sonaba a veredicto agronómico.
   */
  variant?: 'default' | 'device';
}

export default function StatusBadge({ status, size = 'md', variant = 'default' }: Props) {
  const { t } = useTranslation();

  const colors: Record<string, string> = {
    good:   'var(--green)',
    warn:   'var(--amber)',
    alert:  'var(--red)',
    online: 'var(--green)',
    offline: '#555',
    motion: 'var(--red)',
    info:   '#2563eb',
  };

  const bgColors: Record<string, string> = {
    good:   'var(--green-bg)',
    warn:   'var(--amber-bg)',
    alert:  'var(--red-bg)',
    online: 'var(--green-bg)',
    offline: '#f5f5f5',
    motion: 'var(--red-bg)',
    info:   '#eff6ff',
  };

  const fontSize = size === 'sm' ? '9px' : '10px';
  const padding  = size === 'sm' ? '2px 6px' : '3px 8px';

  return (
    <span style={{
      display: 'inline-block', fontSize, padding, borderRadius: '99px',
      background: bgColors[status], color: colors[status], fontWeight: 600,
    }}>
      {t(variant === 'device' ? `status.device.${status}` : `status.${status}`)}
    </span>
  );
}
